export default __webpack_public_path__ + "static/media/searchWhite.30b22295.svg";